import type {TuiCountryIsoCode, TuiLanguage, TuiLanguageCommerce, TuiLanguageCore, TuiLanguageEditor, TuiLanguageKit, TuiLanguageLayout, TuiLanguageTable} from '@taiga-ui/i18n/types';

export const TUI_SLOVENIAN_LANGUAGE_ADDON_COMMERCE: TuiLanguageCommerce = {
    cardNumber: ['Številka', 'Številka kartice'],
    cardExpiry: ['Poteče', 'Datum poteka'],
};

export const TUI_SLOVENIAN_LANGUAGE_LAYOUT: TuiLanguageLayout = {
    inputSearch: {
        popular: 'Priljubljeno',
        history: 'Nedavno',
        placeholder: 'Išči',
        hotkey: 'za iskanje',
        all: 'Vse',
        empty: 'Ni rezultatov',
    },
};

export const TUI_SLOVENIAN_LANGUAGE_KIT: TuiLanguageKit = {
    cancel: 'Prekliči',
    done: 'Končano',
    more: 'Več',
    otherDate: 'Drug datum...',
    showAll: 'Prikaži vse',
    hide: 'Skrij',
    mobileCalendarTexts: [
        'Izberite dan',
        'Izberite obdobje',
        'Izberite dneve',
    ],
    range: ['Od', 'Do'],
    countTexts: ['Več', 'Manj'],
    time: {
        'HH:MM': 'HH:MM',
        'HH:MM AA': 'HH:MM AA',
        'HH:MM:SS': 'HH:MM:SS',
        'HH:MM:SS AA': 'HH:MM:SS AA',
        'HH:MM:SS.MSS': 'HH:MM:SS.MSS',
        'HH:MM:SS.MSS AA': 'HH:MM:SS.MSS AA',
    },
    dateTexts: {
        DMY: 'dan.mesec.leto',
        MDY: 'mesec.dan.leto',
        YMD: 'leto.mesec.dan',
    },
    digitalInformationUnits: ['Bajt', 'Kilobajt', 'Megabajt'],
    passwordTexts: ['Pokaži geslo', 'Skrij geslo'],
    copyTexts: ['Kopiraj', 'Kopirano'],
    shortCalendarMonths: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'Maj',
        'Jun',
        'Jul',
        'Avg',
        'Sep',
        'Okt',
        'Nov',
        'Dec',
    ],
    pagination: ['Prejšnja stran', 'Naslednja stran'],
    fileTexts: {
        loadingError: 'Napaka pri nalaganju',
        preview: 'Predogled',
        remove: 'Odstrani',
    },
    inputFileTexts: {
        defaultLabelSingle: 'ali povleci sem',
        defaultLabelMultiple: 'ali povleci sem',
        defaultLinkSingle: 'Izberi datoteko',
        defaultLinkMultiple: 'Izberi datoteke',
        maxSizeRejectionReason: 'Datoteka je prevelika',
        formatRejectionReason: 'Neveljaven format datoteke',
        drop: 'Spusti datoteko sem',
        dropMultiple: 'Spusti datoteke sem',
    },
    multiSelectTexts: {
        all: 'Izberi vse',
        none: 'Ne izberi ničesar',
    },
    confirm: {
        yes: 'Da',
        no: 'Ne',
    },
    previewTexts: {
        rotate: 'Zavrti',
    },
    zoomTexts: {
        zoomOut: 'Pomanjšaj',
        zoomIn: 'Povečaj',
        reset: 'Ponastavi',
    },
    phoneSearch: 'Išči državo ali kodo',
};

export const TUI_SLOVENIAN_LANGUAGE_ADDON_EDITOR: TuiLanguageEditor = {
    colorSelectorModeNames: ['Enobarvno', 'Barvni gradient'],
    toolbarTools: {
        undo: 'Razveljavi',
        redo: 'Ponovi',
        font: 'Pisava',
        fontStyle: 'Slog pisave',
        fontSize: 'Velikost pisave',
        bold: 'Krepko',
        italic: 'Poševno',
        underline: 'Podčrtano',
        strikeThrough: 'Prečrtano',
        justify: 'Poravnava',
        justifyLeft: 'Poravnaj levo',
        justifyCenter: 'Poravnaj na sredino',
        justifyRight: 'Poravnaj desno',
        justifyFull: 'Poravnaj obojestransko',
        list: 'Seznam',
        indent: 'Povečaj zamik',
        outdent: 'Zmanjšaj zamik',
        unorderedList: 'Neurejen seznam',
        orderedList: 'Urejen seznam',
        quote: 'Citat',
        foreColor: 'Barva besedila',
        backColor: 'Barva ozadja',
        hiliteColor: 'Barva označbe',
        clear: 'Počisti',
        link: 'Povezava',
        attach: 'Priloži datoteko',
        tex: 'Vstavi TeX',
        code: 'Koda',
        image: 'Vstavi sliko',
        insertHorizontalRule: 'Vstavi vodoravno črto',
        superscript: 'Nadpisano',
        subscript: 'Podpisano',
        insertTable: 'Vstavi tabelo',
        insertGroup: 'Vstavi skupino',
        hiliteGroup: 'Označi skupino',
        removeGroup: 'Odstrani skupino',
        insertAnchor: 'Vstavi sidro',
        mergeCells: 'Združi celice',
        splitCells: 'Razdeli celice',
        rowsColumnsManaging: 'Upravljanje vrstic in stolpcev',
        cellColor: 'Barva celice',
        setDetails: 'Nastavi podrobnosti',
        removeDetails: "Odstrani podrobnosti",
    },
    editorEditLink: {
        urlExample: 'primer.com',
        anchorExample: 'sidro',
    },
    editorTableCommands: [
        ['Vstavi stolpec pred', 'Vstavi stolpec za'],
        ['Vstavi vrstico pred', 'Vstavi vrstico za'],
        ['Odstrani stolpec', 'Odstrani vrstico'],
    ],
    editorCodeOptions: ['Koda v besedilu', 'Kodni blok'],
    editorFontOptions: {
        small: 'Majhna',
        large: 'Velika',
        normal: 'Običajna',
        title: 'Naslov',
        subtitle: 'Podnaslov',
    },
};

export const TUI_SLOVENIAN_LANGUAGE_ADDON_TABLE: TuiLanguageTable = {
    showHideText: 'Pokaži/Skrij',
    paginationTexts: {
        pages: 'Strani',
        linesPerPage: 'Vrstic na stran',
        of: 'od',
    },
};

export const TUI_SLOVENIAN_LANGUAGE_CORE: TuiLanguageCore = {
    months: [
        'Januar',
        'Februar',
        'Marec',
        'April',
        'Maj',
        'Junij',
        'Julij',
        'Avgust',
        'September',
        'Oktober',
        'November',
        'December',
    ],
    close: 'Zapri',
    clear: 'Počisti',
    nothingFoundMessage: 'Ni rezultatov',
    defaultErrorMessage: 'Neveljavna vrednost',
    spinTexts: ['Prejšnji', 'Naslednji'],
    shortWeekDays: ['Pon', 'Tor', 'Sre', 'Čet', 'Pet', 'Sob', 'Ned'],
    countries: {} as Record<TuiCountryIsoCode, string>,
};

export const TUI_SLOVENIAN_LANGUAGE: TuiLanguage = {
    name: 'slovenian',
    ...TUI_SLOVENIAN_LANGUAGE_CORE,
    ...TUI_SLOVENIAN_LANGUAGE_KIT,
    ...TUI_SLOVENIAN_LANGUAGE_ADDON_TABLE,
    ...TUI_SLOVENIAN_LANGUAGE_ADDON_COMMERCE,
    ...TUI_SLOVENIAN_LANGUAGE_ADDON_EDITOR,
    ...TUI_SLOVENIAN_LANGUAGE_LAYOUT,
};